<template>
  <div>
    <Title :pages="[{ icon: 'file-invoice-dollar', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <DialogGenerarPaymentOrder 
        :isViewModal="isViewModal"
        :formBtn="formBtn" 
        :dialog="dialog" 
        :parent="parent" 
        :paymentOrder="mainItem"
        @closeDialog="updateDialog" 
        @loadList="loadList(service)" 
        @updateItem="mainItem = $event" 
        :modal_title="modal_title"
      />

      <DialogAutorizar
        :dialog="dialog_autorizar"
        :payment-order-ids="item_autorizar_ids"
        :total-monto-autorizar="total_monto_autorizar"
        @closeDialog="closeDialogAutorizar"
        @loadList="loadList(service)"
      />

      <DialogGenerarPagoMasivo
        :dialog="dialog_generate_payment_masivo"
        :payment-order-ids="payment_order_ids_masivo"
        :payment-orders="payment_orders_masivo"
        @closeDialog="closeDialogGeneratePagoMasivo"
        @loadList="loadList(service, getFilterParams())"
      />

      <DialogExport
        :dialog="dialog_export_modal"
        @closeDialog="closeDialogExport"
        @export="handleExport"
      />

      <DialogGenerarPaymentOrderMasivo
        :dialog="dialog_modal_masive"
        @closeDialog="closeDialogMasivo"
        @loadList="loadList(service)"
      />

      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="primary" class="mb-5" dark v-bind="attrs" v-on="on"> Crear {{ modal_title }} <v-icon right dark> arrow_drop_down </v-icon> </v-btn>
        </template>
        <v-list>
          <v-list-item @click="dialog = true">
            <v-list-item-title>Generar solicitud de pago simple </v-list-item-title>
          </v-list-item>
          <v-list-item @click="dialog_modal_masive = true">
            <v-list-item-title>Generar solicitud de pago multiple</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>



      <v-card>
        <div class="row mb-5 mt-0">
          <div class="col-md-12" v-if="list_access">
            <div class="col-md-12" style="background:white; elevation-0">
              <div class="row pt-5">
                <div class="col-md-3 pt-0">
                  <v-menu ref="desde_selected" v-model="desde_selected_open" :close-on-content-click="false"
                    :close-on-click="false" :return-value.sync="desde_selected" transition="scale-transition" offset-y
                    max-width="290px" min-width="auto" clearable>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="desde_selected" label="Desde" prepend-icon="mdi-calendar" readonly
                        v-bind="attrs" v-on="on" class="pt-0 mt-0"></v-text-field>
                    </template>
                    <v-date-picker v-model="desde_selected" type="date" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="desde_selected_open = false"> Cancel </v-btn>
                      <v-btn text color="primary" @click="$refs.desde_selected.save(desde_selected)"> OK </v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>

                <div class="col-md-3 pt-0">
                  <v-menu ref="hasta_selected" v-model="hasta_selected_open" :close-on-content-click="false"
                    :close-on-click="false" :return-value.sync="hasta_selected" transition="scale-transition" offset-y
                    max-width="290px" min-width="auto" clearable>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="hasta_selected" label="Hasta" prepend-icon="mdi-calendar" readonly
                        v-bind="attrs" v-on="on" class="pt-0 mt-0"></v-text-field>
                    </template>
                    <v-date-picker v-model="hasta_selected" type="date" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="hasta_selected = false"> Cancel </v-btn>
                      <v-btn text color="primary" @click="$refs.hasta_selected.save(hasta_selected)"> OK </v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>

                <div class="col-md-3 pt-0">
                  <v-combobox 
                    v-model="date_search_type" 
                    autocomplete="off" 
                    item-text="name" 
                    item-value="value" 
                    :items="date_search_types" 
                    label="Tipo de búsqueda"
                    class="pt-0 mt-0" 
                    clearable
                  ></v-combobox>
                </div>

                <div class="col-md-3 pt-0">
                  <v-combobox 
                    v-model="supplier_selected" 
                    autocomplete="off" 
                    data-vv-as="supplier_selected"
                    name="supplier_selected" 
                    item-text="name" 
                    item-value="id" 
                    :items="suppliers" 
                    label="Proveedor"
                    class="pt-0 mt-0" 
                    clearable
                  ></v-combobox>
                </div>

                <div class="col-md-3 pt-0">
                  <v-combobox 
                    v-model="state_selected" 
                    autocomplete="off" 
                    item-text="name" 
                    item-value="id" 
                    :items="states" 
                    label="Estado"
                    class="pt-0 mt-0" 
                    clearable
                  ></v-combobox>
                </div>
                <div class="col-md-3 pt-0">
                  <v-text-field 
                    clearable 
                    v-model="nro_orden_selected" 
                    autocomplete="off" 
                    class="pt-0 mt-0"
                    label="Nº Solicitud"
                  ></v-text-field>
                </div>

                <div class="col-md-3 pt-0">
                  <v-combobox 
                    v-model="payment_method_selected" 
                    autocomplete="off" 
                    item-text="name" 
                    item-value="id" 
                    :items="payment_methods" 
                    label="Forma de pago"
                    class="pt-0 mt-0" 
                    clearable
                  ></v-combobox>
                </div>

                <div class="col-md-3 pt-0">
                  <v-combobox 
                    v-model="money_account_selected" 
                    autocomplete="off" 
                    item-text="name" 
                    item-value="id" 
                    :items="money_accounts" 
                    label="Cuenta"
                    class="pt-0 mt-0" 
                    clearable
                  ></v-combobox>
                </div>

                <div class="col-md-12 d-flex justify-end pt-0">
                  <v-btn color="blue-grey" class="mr-2" dark :loading="loading_export" @click="openExportDialog"> 
                    Exportar
                    <font-awesome-icon class="ml-2" icon="download" />
                  </v-btn>

                  <v-btn color="info" class="" @click="filter">Buscar</v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card>

      <v-card v-if="list_access">
        <v-card-title>
          <span class="text-uppercase">{{ page_title }}</span>
          <v-spacer></v-spacer>
          <v-text-field 
            v-model="search" 
            append-icon="search" 
            label="Buscar" 
            single-line 
            hide-details
          ></v-text-field>
        </v-card-title>
        <div v-if="selected.length > 0" class="col-md-12" style="background: #f4f1f1">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" color="green" class="cursor mb-1 mt-1 mr-2" @click="autorizarMasivo">mdi-check-circle</v-icon>
            </template>
            <span>Autorizar / Rechazar seleccionados</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" color="purple" class="cursor mb-1 mt-1 mr-2" @click="generarPagoMasivo">mdi-cash-multiple</v-icon>
            </template>
            <span>Generar pago masivamente</span>
          </v-tooltip>
          <v-tooltip bottom v-if="sensible_access">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" color="orange darken-2" class="cursor mb-1 mt-1 mr-2" @click="revertirMasivo">mdi-undo-variant</v-icon>
            </template>
            <span>Revertir seleccionados a Pendiente</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" color="red" class="cursor mb-1 mt-1 mr-2" @click="eliminarMasivo">mdi-delete-sweep</v-icon>
            </template>
            <span>Eliminar seleccionados</span>
          </v-tooltip>
        </div>
        <v-data-table 
          :headers="headers" 
          :items="list" 
          :search="search" 
          :custom-filter="customSearch"
          :loading="loading" 
          loading-text="Cargando..."
          :options="{ descending: true, itemsPerPage: 15 }" 
          @pagination="updatePagination" 
          :footer-props="{ itemsPerPageOptions: [5, 10, 15, 50, -1] }"
          v-model="selected"
          show-select
          :single-select="false"
          item-key="id"
        >
          <template v-slot:item="{ item, isSelected, select }">
            <tr>
              <td>
                <v-checkbox
                  v-if="parseFloat(item.state) === service.STATE_PENDING || parseFloat(item.state) === service.STATE_AUTHORIZED || parseFloat(item.state) === service.STATE_REJECTED"
                  :input-value="isSelected" 
                  style="margin: 0px; padding: 0px" 
                  hide-details 
                  @change="select($event)" 
                />
              </td>
              <td>{{ item.nro_orden }}</td>
              <td>{{ formatUtils.formatDateString(item.cbte_fch) }}</td>
              <td>{{ item.estimated_payment_date ? formatUtils.formatDateString(item.estimated_payment_date) : '-' }}</td>
                <td>
                  <div v-if="item.payment_method_id">{{ item.payment_method_name }}</div>
                  <div v-if="item.money_account_id" class="text-caption grey--text">{{ item.money_account_name }}</div>
                  <div v-if="!item.payment_method_id" class="grey--text">-</div>
                </td>
                <td>{{ item.supplier_name }}</td>
              <td class="text-right grey--text text--darken-1">{{ formatUtils.formatPrice(item.imp_total) }}</td>
              <td class="text-right grey--text text--darken-1">({{ formatUtils.formatPrice(getTotalRetenciones(item)) }})</td>
              <td class="text-right font-weight-bold">{{ formatUtils.formatPrice(item.amount) }}</td>
              <td>
                <div class="status-badge font-weight-medium mb-0" :class="'payment-status-' + parseFloat(item.state)">
                  {{ getStateName(item.state)  }}
                </div>
                <div v-if="item.associated_payment_nro_recibo" class="text-caption grey--text">
                  Pago #{{ item.associated_payment_nro_recibo }}
                </div>
              </td>
              <td>
                <div v-if="item.authorized_by_user_id">
                  <div class="font-weight-bold text-body-2 mt-1">
                    {{ item.authorized_by_user_business_name }}
                  </div>
                  <div class="text-caption grey--text">
                    {{ formatUtils.formatDateTimeString(item.authorized_date) }}
                  </div>
                  <div v-if="item.authorized_observation" class="text-caption grey--text text--darken-1">
                    <v-tooltip bottom max-width="300">
                      <template v-slot:activator="{ on }">
                        <div v-on="on" class="d-flex align-center">
                          <div class="text-truncate observation-text">{{ item.authorized_observation }}</div>
                        </div>
                      </template>
                      <span>{{ item.authorized_observation }}</span>
                    </v-tooltip>
                  </div>
                </div>
                <div v-else class="grey--text">-</div>
              </td>
              <td class="text-right px-3">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small color="blue" class="mr-2" @click="viewItem(item)"> 
                      remove_red_eye
                    </v-icon>
                  </template>
                  <span>Ver</span>
                </v-tooltip>

                <!-- // agregar constantes de estado en el service y usar aquí para comparar -->

                <v-tooltip bottom v-if="parseFloat(item.state) === service.STATE_PENDING && update_access">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small color="orange" class="mr-2" @click="editItem(item)">
                      edit
                    </v-icon>
                  </template>
                  <span>Editar</span>
                </v-tooltip>

                <v-tooltip bottom v-if="parseFloat(item.state) === service.STATE_PENDING && sensible_access">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small color="green" class="mr-2" @click="openAutorizar([item.id], parseFloat(item.imp_total || 0))">
                      mdi-check-circle
                    </v-icon>
                  </template>
                  <span>Autorizar / Rechazar</span>
                </v-tooltip>

                <v-tooltip bottom v-if="(parseFloat(item.state) === service.STATE_AUTHORIZED || parseFloat(item.state) === service.STATE_REJECTED) && sensible_access">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small color="orange darken-2" class="mr-2" @click="revertirOrden(item)">
                      mdi-undo-variant
                    </v-icon>
                  </template>
                  <span>Revertir a Pendiente de Aprobación</span>
                </v-tooltip>

                <!-- //getModuleAccess('spent_payments', 'create') para verificar acceso a generación de pago desde orden de pago -->
                <v-tooltip bottom v-if="parseFloat(item.state) === service.STATE_AUTHORIZED && getModuleAccess('spent_payments', 'create')">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small color="purple" class="mr-2" @click="generarPago(item)"> 
                      mdi-cash-register
                    </v-icon>
                  </template>
                  <span>Generar Pago</span>
                </v-tooltip>

                <v-tooltip bottom v-if="canDeleteOrder(item)">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small color="red" class="mr-2" @click="deleteItem(item)"> 
                      delete 
                    </v-icon>
                  </template>
                  <span>Eliminar</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
              {{ "Busqueda sin resultados - " + search }}
            </v-alert>
          </template>
        </v-data-table>
      </v-card>

      <DialogDelete 
        :dialog_delete="dialog_delete" 
        @updateDialogDelete="updateDialogDelete"
        @deleteItemConfirm="deleteItemConfirm" 
        @reload="filter" 
      />

      <DialogDelete
        :dialog_delete="dialog_delete_masivo"
        @updateDialogDelete="dialog_delete_masivo = $event"
        @deleteItemConfirm="deleteMultipleConfirm"
        @reload="filter"
      />

      <DialogYesNo
        :open="dialog_revertir"
        title="Revertir solicitud de pago"
        :message="'¿Desea revertir ' + (revertir_ids.length > 1 ? revertir_ids.length + ' solicitudes' : 'la solicitud') + ' a estado Pendiente de Aprobación?'"
        nameAccept="Revertir"
        nameCancel="Cancelar"
        :loading="loading_revertir"
        @accept="revertirConfirm"
        @cancel="dialog_revertir = false"
      />

      <ModalSpentPayment
        :dialog="open_generate_payment"
        :spentPayment="spentPaymentFromOrder"
        :formBtn="'Crear Pago'"
        :openFromPaymentOrder="true"
        @closeDialog="closePayment"
        @loadList="filter"
      />
    </v-container>
  </div>
</template>

<script>
import Constant from "@/constants/sections";
import { generalService } from "@/libs/ws/generalService";
import { paymentOrderService } from "@/libs/ws/paymentOrderService";
import { formatUtils } from "@/libs/utils/formatUtils";
import GenericMixin from "@/mixins/GenericMixin.vue";
import Title from "@/components/Title.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import DialogDelete from "@/components/DialogDelete.vue";
import DialogGenerarPaymentOrder from "@/views/PaymentOrder/DialogGenerarPaymentOrder.vue";
import DialogGenerarPaymentOrderMasivo from "@/views/PaymentOrder/DialogGenerarPaymentOrderMasivo.vue";
import DialogAutorizar from "@/views/PaymentOrder/DialogAutorizar.vue";
import DialogGenerarPagoMasivo from "@/views/PaymentOrder/DialogGenerarPagoMasivo.vue";
import DialogExport from "@/views/PaymentOrder/DialogExport.vue";
import ModalSpentPayment from "@/views/Spents/ModalSpentPayment.vue";
import ExportMixin from "@/mixins/ExportMixin.vue";
import DialogYesNo from "@/components/DialogYesNo.vue";

const STATE_NAMES = {
  [paymentOrderService.STATE_PENDING]: paymentOrderService.STATE_PENDING_NAME,
  [paymentOrderService.STATE_AUTHORIZED]: paymentOrderService.STATE_AUTHORIZED_NAME,
  [paymentOrderService.STATE_PAID]: paymentOrderService.STATE_PAID_NAME,
  [paymentOrderService.STATE_REJECTED]: paymentOrderService.STATE_REJECTED_NAME,
};

function getStateNameById(state) {
  return STATE_NAMES[parseFloat(state)] || "Desconocido";
}

function matchText(search, values) {
  if (search === null || search === undefined || search.toString().trim() === "") return true;
  const needle = search.toString().trim().toLocaleLowerCase();
  return values.some((value) => value !== null && value !== undefined && value.toString().toLocaleLowerCase().indexOf(needle) !== -1);
}

/*
Devuelve la fecha cruda y la formateada (dd/mm/yyyy) para poder buscar por cualquiera de las dos.
*/
function dateSearchValues(date_string) {
  if (!date_string) return [];
  const date = date_string.toString().split(" ")[0];
  return [date, formatUtils.formatDateString(date)];
}

export default {
  components: { Title, DialogDelete, DialogGenerarPaymentOrder, DialogGenerarPaymentOrderMasivo, DialogAutorizar, DialogGenerarPagoMasivo, DialogExport, ModalSpentPayment, DialogYesNo },
  mixins: [GenericMixin, RolMixin, ExportMixin],
  data() {
    return {
      selected: [],
      formatUtils: formatUtils,
      parent: this,
      service: paymentOrderService,
      page_title: "Solicitudes de Pago",
      modal_title: "Solicitud de Pago",
      dialog_modal_masive: false,
      mainItem: {
        id: 0,
        supplier: null,
        receiver: null,
        cbte_fch: new Date(new Date().toLocaleDateString("en-US", { timeZone: "America/Buenos_Aires" })).toISOString().slice(0, 10),
        estimated_payment_date: new Date(new Date().toLocaleDateString("en-US", { timeZone: "America/Buenos_Aires" })).toISOString().slice(0, 10),
        dolar_cotiz: null,
        amount: 0,
        imp_total: 0,
        observation: null,
        supplier_bank: null,
        spents: [],
        tributes: [],
        state: 0
      },
      dialog_delete: false,
      dialog_delete_masivo: false,
      dialog_autorizar: false,
      item_autorizar_ids: [],
      total_monto_autorizar: 0,
      dialog_generate_payment_masivo: false,
      payment_order_ids_masivo: [],
      payment_orders_masivo: [],
      open_generate_payment: false,
      spentPaymentFromOrder: null,
      defaultItem: null,
      dialog_export_modal: false,
      loading_export: false,
      dialog_revertir: false,
      revertir_ids: [],
      loading_revertir: false,
      headers: [
        { text: "Nº Solicitud", align: "left", sortable: true, value: "nro_orden" },
        { text: "Fecha", align: "left", sortable: true, value: "cbte_fch" },
        { text: "Fecha Est. Pago", align: "left", sortable: true, value: "estimated_payment_date" },
        { text: "Forma de Pago", align: "left", sortable: true, value: "payment_method_name" },
        { text: "Proveedor", align: "left", sortable: true, value: "supplier_name" },
        { text: "Total a imputar", align: "right", sortable: true, value: "imp_total" },
        { text: "Total Retenciones", align: "right", sortable: false, filterable: false },
        { text: "Total a pagar", align: "right", sortable: true, value: "amount" },
        { text: "Estado", align: "left", sortable: true, value: "state" },
        { text: "Autorizado Por", align: "left", sortable: true, value: "authorized_by_user_business_name" },
        { text: "Acción", value: "", align: "center", width: "150px", sortable: false, filterable: false },
      ],
      list: [],
      suppliers: [],
      states: [],
      date_search_types: [
        { name: 'Fecha de creación', value: 'creation_date' },
        { name: 'Fecha estimada de pago', value: 'estimated_payment_date' }
      ],
      date_search_type: { name: 'Fecha de creación', value: 'creation_date' },
      desde_selected_open: false,
      hasta_selected_open: false,
      supplier_selected: null,
      state_selected: null,
      nro_orden_selected: null,
      payment_method_selected: null,
      money_account_selected: null,
      payment_methods: [],
      money_accounts: [],
      desde_selected: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().slice(0, 10),
      hasta_selected: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().slice(0, 10),
    };
  },
  mounted() {
    this.loadComboData();
    this.defaultItem = JSON.parse(JSON.stringify(this.mainItem));
    this.loadList(this.service, this.getFilterParams());
  },
  computed: {
    isViewModal() {
      return this.formBtn == "";
    },
  },
  methods: {
    getStateName(state) {
      return getStateNameById(state);
    },
    /*
    Buscador general de la tabla: matchea contra todos los datos visibles de la fila
    (proveedor, forma de pago, cuenta, estado, fechas formateadas, etc.).
    */
    customSearch(value, search, item) {
      return matchText(search, [
        item.nro_orden,
        ...dateSearchValues(item.cbte_fch),
        ...dateSearchValues(item.estimated_payment_date),
        item.payment_method_name,
        item.money_account_name,
        item.supplier_name,
        item.supplier_cuit,
        item.imp_total,
        item.amount,
        getStateNameById(item.state),
        item.associated_payment_nro_recibo,
        item.authorized_by_user_business_name,
        item.authorized_observation,
      ]);
    },
    openAutorizar(ids, totalMonto = 0) {
      this.item_autorizar_ids = ids;
      this.total_monto_autorizar = totalMonto;
      this.dialog_autorizar = true;
    },
    closeDialogAutorizar() {
      this.item_autorizar_ids = [];
      this.total_monto_autorizar = 0;
      this.dialog_autorizar = false;
      this.selected = [];
      this.loadList(this.service, this.getFilterParams());
    },
    autorizarMasivo() {
      if (this.selected.length === 0) {
        this.$toast.error("Debe seleccionar al menos una solicitud de pago", "Error");
        return;
      }
      
      // Filtrar solo las órdenes en estado Pendiente de Aprobación
      
      const pendingOrders = this.selected.filter(item => {
        console.log("parseFloat(item.state)", parseFloat(item.state));
        if (parseFloat(item.state) !== paymentOrderService.STATE_PENDING) {
          return false;
        }
        return true;  
      })
      
      if (pendingOrders.length === 0) {
        this.$toast.error("Las órdenes seleccionadas no están en estado Pendiente de Aprobación", "Error");
        return;
      }
      
      const ids = pendingOrders.map(item => item.id);
      const totalMonto = pendingOrders.reduce((acc, item) => {
        return acc + parseFloat(item.imp_total || 0);
      }, 0);
      this.openAutorizar(ids, totalMonto);
    },
    generarPagoMasivo() {
      if (this.selected.length === 0) {
        this.$toast.error("Debe seleccionar al menos una solicitud de pago", "Error");
        return;
      }
      
      // Filtrar solo las órdenes en estado Autorizado
      const authorizedOrders = this.selected.filter(item => {
        return parseFloat(item.state) === paymentOrderService.STATE_AUTHORIZED;
      });
      
      if (authorizedOrders.length === 0) {
        this.$toast.error("Las órdenes seleccionadas no están en estado Autorizado", "Error");
        return;
      }

      // Permitir órdenes sin forma/cuenta, pero si existen configuraciones completas
      // en más de una orden deben coincidir entre sí.
      const ordersWithPaymentConfig = authorizedOrders.filter((item) => {
        return (
          item.payment_method &&
          item.payment_method.id &&
          item.money_account &&
          item.money_account.id
        );
      });

      if (ordersWithPaymentConfig.length > 1) {
        const firstOrderWithConfig = ordersWithPaymentConfig[0];
        const firstPaymentMethodId = firstOrderWithConfig.payment_method.id;
        const firstMoneyAccountId = firstOrderWithConfig.money_account.id;

        const samePaymentConfig = ordersWithPaymentConfig.every((item) => {
          return (
            item.payment_method.id === firstPaymentMethodId &&
            item.money_account.id === firstMoneyAccountId
          );
        });

        if (!samePaymentConfig) {
          this.$toast.error("Para generar pagos masivos, todas las órdenes deben tener la misma forma de pago y cuenta de tesoreria", "Error");
          return;
        }
      }

      const ids = authorizedOrders.map(item => item.id);
      this.payment_order_ids_masivo = ids;
      this.payment_orders_masivo = JSON.parse(JSON.stringify(authorizedOrders));
      this.dialog_generate_payment_masivo = true;
    },
    closeDialogGeneratePagoMasivo() {
      this.payment_order_ids_masivo = [];
      this.payment_orders_masivo = [];
      this.dialog_generate_payment_masivo = false;
      this.selected = [];
      this.loadList(this.service, this.getFilterParams());
    },

    generarPago(item) {
      if (!this.getModuleAccess('spent_payments', 'create')) {
        this.$toast.error("No tiene permisos para crear pagos de gastos", "Error");
        return;
      }

      this.loading = true;
      paymentOrderService.get(item.id)
        .then((response) => {
          if (!response.status) {
            this.$toast.error(response.msg, "Error");
            return;
          }
          const fullItem = response.result;

          const spents = JSON.parse(JSON.stringify(fullItem.spents)).map(spent => ({ ...spent, id: 0 }));

          if (fullItem.pago_a_cuenta && parseFloat(fullItem.pago_a_cuenta) > 0) {
            spents.push({
              id: 0,
              spent: {
                id: 0,
                cbte_fch: new Date().toISOString().split('T')[0],
                spent_number_label: "Pago a cuenta",
                voucher_number: null
              },
              imp_total: parseFloat(fullItem.pago_a_cuenta)
            });
          }

          this.spentPaymentFromOrder = {
            id: 0,
            supplier: fullItem.supplier,
            receiver: fullItem.receiver,
            spents: spents,
            tributes: JSON.parse(JSON.stringify(fullItem.tributes)).map(tribute => ({ ...tribute, id: 0 })),
            spent_payment_methods: [{
              id: 0,
              payment_method: fullItem.payment_method,
              money_account: fullItem.money_account,
              amount: fullItem.amount,
              fch_payment_efective: fullItem.estimated_payment_date || null,
              reference: null
            }],
            cbte_fch: new Date(new Date().toLocaleDateString("en-US", { timeZone: "America/Buenos_Aires" })).toISOString().slice(0, 10),
            dolar_cotiz: fullItem.dolar_cotiz,
            observation: null,
            file: null,
            file_base64: null,
            payment_order_id: fullItem.id
          };
          this.open_generate_payment = true;
        })
        .catch((e) => {
          console.log("paymentOrderService.get error", e);
          this.$toast.error("Error al cargar la solicitud de pago", "Error");
        })
        .finally(() => { this.loading = false; });
    },
    closePayment() {
      this.spentPaymentFromOrder = null;
      this.open_generate_payment = false;
    },
    getFilterParams() {
      const param = {
        from: this.desde_selected,
        to: this.hasta_selected,
        supplier: this.supplier_selected != null ? this.supplier_selected.id : null,
        state: this.state_selected != null ? this.state_selected.id : null,
        nro_orden: this.nro_orden_selected,
        date_search_type: this.date_search_type != null ? this.date_search_type.value : 'creation_date',
        payment_method: this.payment_method_selected != null ? this.payment_method_selected.id : null,
        money_account: this.money_account_selected != null ? this.money_account_selected.id : null,
      };
      return param;
    },
    filter() {
      this.loadList(this.service, this.getFilterParams());
    },
    loadComboData() {
      generalService.setSection(Constant.SECTION_SUPPLIERS);
      generalService
        .filter()
        .then((response) => {
          this.suppliers = response.result;
        })
        .catch((e) => {
          console.log("suppliers.filter error");
          console.log(e);
        });

      paymentOrderService
        .list_states()
        .then((response) => {
          if (response.status) {
            this.states = response.result;
          }
        })
        .catch((e) => {
          console.log("paymentOrderService.list_states error");
          console.log(e);
        });

      generalService.setSection(Constant.SECTION_PAYMENT_METHODS);
      generalService
        .filter()
        .then((response) => {
          this.payment_methods = response.result;
        })
        .catch((e) => {
          console.log("payment_methods.filter error");
          console.log(e);
        });

      generalService.setSection(Constant.SECTION_MONEY_ACCOUNTS);
      generalService
        .filter()
        .then((response) => {
          this.money_accounts = response.result;
        })
        .catch((e) => {
          console.log("money_accounts.filter error");
          console.log(e);
        });
    },
    deleteItemConfirm() {
      this.loading = true;
      paymentOrderService
        .remove({ id: this.deleteId })
        .then((response) => {
          if (response.status === true) {
            this.$toast.success(response.msg, "OK");
            this.loadList(this.service, this.getFilterParams());
          } else {
            if (Object.prototype.hasOwnProperty.call(response, "message")) {
              this.$toast.error(response.message, "Error");
            } else {
              this.$toast.error(response.msg, "Error");
            }
          }
        })
        .catch((e) => {
          console.log("paymentOrderService.remove error");
          console.log(e);
          this.$toast.error("Error exception", "Error");
        })
        .finally(() => {
          this.loading = false;
        });
      this.dialog_delete = false;
    },
    getTotalImputar(item) {
      if (!item.spents || !Array.isArray(item.spents)) return 0;
      
      const spentsTotal = item.spents.reduce((total, spent) => {
        return total + parseFloat(spent.imp_total || 0);
      }, 0);
      
      const pagoACuenta = parseFloat(item.pago_a_cuenta || 0);
      
      return spentsTotal + pagoACuenta;
    },
    getTotalRetenciones(item) {
      // if (!item.tributes || !Array.isArray(item.tributes)) return 0;
      return parseFloat(item.imp_total) - parseFloat(item.amount);
    },
    getTotalPagar(item) {
      // if (!item.tributes || !Array.isArray(item.tributes)) return parseFloat(item.amount);
      return parseFloat(item.amount) - (parseFloat(item.imp_total) - parseFloat(item.amount));
    },
    openExportDialog() {
      this.dialog_export_modal = true;
    },
    closeDialogExport() {
      this.dialog_export_modal = false;
    },
    closeDialogMasivo() {
      this.dialog_modal_masive = false;
    },
    handleExport(exportConfig) {
      if (exportConfig.type === 'standard') {
        this.exportToExcel();
      } else if (exportConfig.type === 'bank_transfer') {
        // Por ahora solo ICBC está implementado (code 7)
        if (exportConfig.bank && exportConfig.bank.code === paymentOrderService.BANK_ICBC_CODE) {
          this.exportBankTransfer(exportConfig.bank);
        }
      }
    },
    exportToExcel() {
      if (this.loading_export) return;
      this.loading_export = true;
      let param = this.getFilterParams();

      this.service
        .export_filter(param)
        .then((response) => {
          if (Object.prototype.toString.call(response) != "[object ArrayBuffer]" && !response.status) {
            this.$toast.error(response.msg, "Error");
            this.loading_export = false;
            return;
          }

          let blob = new Blob([response], {
            type: "application/vnd.ms-excel",
          });
          let link = document.createElement("a");
          //link.setAttribute('download', "export")
          link.download = "SolicitudesDePago.xlsx";
          link.href = window.URL.createObjectURL(blob);
          link.target = "_blank";
          link.click();
          this.loading_export = false;
        })
        .catch((e) => {
          console.log("service.export_filter sale orders error");
          console.log(e);
          this.loading_export = false;
        });
    },
    exportBankTransfer(bank) {
      if (this.loading_export) return;
      this.loading_export = true;
      let param = this.getFilterParams();
      param.state = paymentOrderService.STATE_AUTHORIZED;

      this.service
        .export_bank_icbc(param)
        .then((response) => {
          if (Object.prototype.toString.call(response) != "[object ArrayBuffer]" && !response.status) {
            this.$toast.error(response.msg, "Error");
            this.loading_export = false;
            return;
          }

          let blob = new Blob([response], {
            type: "application/vnd.ms-excel",
          });
          let link = document.createElement("a");
          link.download = "Transferencias_ICBC.xlsx";
          link.href = window.URL.createObjectURL(blob);
          link.target = "_blank";
          link.click();
          this.loading_export = false;
          this.$toast.success("Archivo exportado correctamente", "Éxito");
        })
        .catch((e) => {
          console.log("service.export_bank_icbc error");
          console.log(e);
          this.loading_export = false;
          this.$toast.error("Error al exportar archivo", "Error");
        });
    },
    revertirOrden(item) {
      this.revertir_ids = [item.id];
      this.dialog_revertir = true;
    },
    revertirMasivo() {
      if (this.selected.length === 0) {
        this.$toast.error("Debe seleccionar al menos una solicitud de pago", "Error");
        return;
      }

      const revertibles = this.selected.filter(item => {
        const state = parseFloat(item.state);
        return state === paymentOrderService.STATE_AUTHORIZED || state === paymentOrderService.STATE_REJECTED;
      });

      if (revertibles.length === 0) {
        this.$toast.error("Ninguna de las órdenes seleccionadas está en estado Aprobado o Rechazado", "Error");
        return;
      }

      this.revertir_ids = revertibles.map(item => item.id);
      this.dialog_revertir = true;
    },
    revertirConfirm() {
      this.loading_revertir = true;
      paymentOrderService
        .revert({ ids: this.revertir_ids })
        .then((response) => {
          if (response.status) {
            this.$toast.success(response.msg, "OK");
            if (response.result && response.result.error_count > 0) {
              response.result.errors.forEach(err => this.$toast.warning(err, "Aviso"));
            }
          } else {
            this.$toast.error(response.msg, "Error");
          }
          this.selected = [];
          this.loadList(this.service, this.getFilterParams());
        })
        .catch((e) => {
          console.log("paymentOrderService.revert error", e);
          this.$toast.error("Error al revertir las solicitudes de pago", "Error");
        })
        .finally(() => {
          this.loading_revertir = false;
          this.dialog_revertir = false;
          this.revertir_ids = [];
        });
    },
    canDeleteOrder(item) {
      // No se puede eliminar si state = PAID (2)
      if (parseFloat(item.state) === 2) {
        return false;
      }

      // Si está APROBADO (1) o RECHAZADO (3), solo puede eliminar quien autorizó/rechazó
      if (parseFloat(item.state) === 1 || parseFloat(item.state) === 3) {
        const appObject = this.getAppObject();
        if (!appObject || !appObject.id) {
          return false;
        }
        if (!item.authorized_by_user || !item.authorized_by_user.id) {
          return false;
        }
        return appObject.id === item.authorized_by_user.id;
      }

      // Para otros estados (PENDING_APPROVAL), verificar delete_access
      return this.delete_access;
    },
    eliminarMasivo() {
      if (this.selected.length === 0) {
        this.$toast.error("Debe seleccionar al menos una solicitud de pago", "Error");
        return;
      }

      const deletableOrders = this.selected.filter(item => this.canDeleteOrder(item));

      if (deletableOrders.length === 0) {
        this.$toast.error("Ninguna de las órdenes seleccionadas puede eliminarse", "Error");
        return;
      }

      this.dialog_delete_masivo = true;
    },
    deleteMultipleConfirm() {
      const deletableOrders = this.selected.filter(item => this.canDeleteOrder(item));
      const ids = deletableOrders.map(item => item.id);

      this.loading = true;
      paymentOrderService
        .remove_multiple({ ids })
        .then((response) => {
          if (response.status) {
            this.$toast.success(response.msg, "OK");
            if (response.result && response.result.error_count > 0) {
              response.result.errors.forEach(err => this.$toast.warning(err, "Aviso"));
            }
          } else {
            this.$toast.error(response.msg, "Error");
          }
          this.selected = [];
          this.loadList(this.service, this.getFilterParams());
        })
        .catch((e) => {
          console.log("paymentOrderService.remove_multiple error", e);
          this.$toast.error("Error al eliminar las solicitudes de pago", "Error");
        })
        .finally(() => {
          this.loading = false;
          this.dialog_delete_masivo = false;
        });
    },

  },
};
</script>

<style scoped>
.observation-text {
  max-width: 150px;
}
</style>
